import { IInifiniteScroll } from "../models";
import {
	INFINITE_SCROLL_START,
    INFINITE_SCROLL_END,
	GET_FUNDS_START,
	Actions
} from "../actions";
import { appendToLoading, removeFromLoading } from "../utils";

export function infiniteScrollReducer(state: IInifiniteScroll = { offset: 0, loading: false }, action:Actions) {
	let current;
	switch (action.type) {
		case INFINITE_SCROLL_START:
			return action.payload;
		case INFINITE_SCROLL_END:
            return Object.assign({}, state, { loading: false });
		case GET_FUNDS_START:
			return Object.assign({}, state, { offset: 0 });
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/infiniteScroll.ts